export default __webpack_public_path__ + "static/media/assessment-submitted.9f7efb5b.svg";